module.exports = __webpack_public_path__ + "static/img/pin_green.2bb2701.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/icons/pin_green.png
// module id = 722
// module chunks = 6